module.exports = __webpack_public_path__ + "img/dermatologic.2d9cc8be.svg";